import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import type { ComponentType } from "@repo/editor/types";
import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";
import React, { forwardRef } from "react";
import * as t from "@rekajs/types";
import CroppedSection from "../components/common/cropped-section";

export const departmentContactsDefinition: ComponentSettingsProps = {
  title: {
    type: "string",
    label: "عنوان",
  },
};

interface DepartmentContactsProps {
  children: ReactNode;
  title: string;
}

const DepartmentContactsComponent = forwardRef<
  HTMLDivElement,
  DepartmentContactsProps
>((props, ref) => {
  return (
    <>
      <CroppedSection fill="#f7f8fc" />
      <div
        className="bg-[#f7f8fc] flex items-center justify-center p-10"
        ref={ref}
      >
        <div className="max-w-7xl w-full flex flex-col gap-10 lg:gap-16">
          <h2 className="lg:text-5xl text-3xl font-helvetica font-[100] uppercase text-gray-700 mb-2">
            {props.title}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-10 gap-y-16">
            {props.children}
          </div>
        </div>
      </div>
      <div className="relative scale-[-1] -mb-[27.3%]">
        <CroppedSection fill="#f7f8fc" />
      </div>
    </>
  );
});

DepartmentContactsComponent.displayName = "DepartmentContacts";

export const DepartmentContacts = observer(
  DepartmentContactsComponent
) as unknown as ComponentType<DepartmentContactsProps>;

export const departmentContactsSettings: ComponentSettings = {
  name: "EDepartmentContacts",
  props: departmentContactsDefinition,
  childrenAllowed: true,
  label: "تماس با بخش",
  widgets: {
    label: "تماس با بخش",
    template: () =>
      t.componentTemplate({
        component: t.identifier({
          name: "EDepartmentContacts",
          external: true,
        }),
      }),
  },
};

DepartmentContacts.componentSettings = departmentContactsSettings;
